import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { css, Label } from './UI';

// Cuenta de la compañía de la que salió el pago (backend: utils/cuentaPago.js).
// Tesorería la elige al marcar el pago como pagado. Si la compañía tiene una sola
// cuenta, ya viene elegida; si no tiene ninguna dada de alta, no se exige.
export const etiquetaCuenta = (c) => (c ? [c.banco, c.terminacion && `••${c.terminacion}`].filter(Boolean).join(' ') : '');

export function SelectorCuentaPago({ empresa, value, onChange }) {
  const [cuentas, setCuentas] = useState(null);
  useEffect(() => {
    if (!empresa) { setCuentas([]); return; }
    let vivo = true;
    api.get(`/cuentas-bancarias?empresa=${encodeURIComponent(empresa)}`)
      .then(lista => {
        if (!vivo) return;
        setCuentas(lista);
        if (!value && lista.length === 1) onChange(lista[0]._id);
        else if (!value && lista.some(c => c.principal)) onChange(lista.find(c => c.principal)._id);
      })
      .catch(() => vivo && setCuentas([]));
    return () => { vivo = false; };
  }, [empresa]); // eslint-disable-line react-hooks/exhaustive-deps

  if (cuentas === null) return null;
  if (!cuentas.length) return (
    <div style={{ fontSize: 12, color: 'var(--glass)' }}>
      {empresa} aún no tiene cuentas bancarias dadas de alta: el pago se registra sin cuenta. Admin o Finanzas las agregan en Cuentas Bancarias.
    </div>
  );
  return (
    <div>
      <Label required>Cuenta de la que salió el pago</Label>
      <select value={value || ''} onChange={e => onChange(e.target.value)} style={css.select(!value)}>
        <option value="">Elige la cuenta…</option>
        {cuentas.map(c => <option key={c._id} value={c._id}>{etiquetaCuenta(c)}{c.principal ? ' · principal' : ''}</option>)}
      </select>
    </div>
  );
}
